import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Form, Button, Input, Modal, Typography, Select } from 'antd';
import {
  getUserPermissionTemplateRequest,
  getUserProfileImage,
  getUserRequest,
  updateUserRequest,
  getAllUsersRequest
} from '../../UserApiActions';

import ConstantMessages from '../../../../utils/Strings';
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon'
import Notification from '../../../../utils/Notification';

import './EditUser.css';
import ActivateOrDeactivateUser from '../ActivateOrDeactivateUser/ActivateOrDeactivateUser';
import ResetPassword from '../../../Authentication/components/ResetPasswordV2/ResetPassword'
import MobileNumber from '../../../../utils/components/MobileNumber/MobileNumber';
import { HUMAN_READABLE_SYSTEM_ROLES, SYSTEM_ROLES } from '../../../../utils/Constants';

const notification = new Notification();
const { Item: FormItem } = Form;

let EditUserFormComponent = (props) => {
  const { form, user } = props;
  // const { getFieldDecorator } = form;
  const [showActivateDeactivateUserModal, setShowActivateDeactivateUserModal] = useState(false)
  const [showResetUserPasswordModal, setShowResetUserPasswordModal] = useState(false)

  console.log('------user-------', user)
  // TODO: replace role default values
  const roles = [SYSTEM_ROLES.ORG_MANAGER, SYSTEM_ROLES.ANALYST]
  const isSuperAdmin = user.roles?.[0].name === SYSTEM_ROLES.SUPER_ADMIN

  useEffect(() => {
    if(user) {
      form.setFieldsValue({
        firstName: user.firstName,
        lastName: user.lastName,
        username: user.username,
        location: user.location || '',
        phone: user.phone,
        role: user.roles?.[0].name ?? ''
      });
    }
  }, [form, user])

  const fieldsConfig = {
    firstName: {
      // initialValue: user?.firstName,
      rules: [
        { required: true, whitespace: true, message: ConstantMessages.firstNameRequired },
        { max: 50, message: 'Maximum 50 characters allowed' }
      ]
    },
    lastName: {
      // initialValue: user?.lastName,
      rules: [
        { required: true, whitespace: true, message: ConstantMessages.lastNameRequired },
        { max: 50, message: 'Maximum 50 characters allowed' }
      ]
    },
    username: {
      // initialValue: user?.username,
      rules: [
        { type: 'email', message: ConstantMessages.enterValidEmailAddress },
        { required: true, whitespace: true, message: ConstantMessages.emailAddressRequired }
      ]
    },
    location: {
      // initialValue: user?.location,
      rules: [
        { required: true, whitespace: true, message: ConstantMessages.locationRequired },
        { max: 255, message: 'Maximum 255 characters allowed' }
      ]
    },
    role: {
      rules: [
        { required: true, whitespace: true, message: 'Please select role' },
      ]
    }
  };

  const handleUpdateUser = (userId, data) => {
    props.updateUserRequest(userId, data).then(() => {
      notification.show('info', 'Update User', 'User account updated');
      props.getAllUsers()
    });
  };

  const handleSubmit = formData => {
    if (formData.phone.charAt(0) !== '+') {
      formData.phone = `+${formData.phone}`
    }
    handleUpdateUser(user.id, formData);
  };

  return (
    <>
    <Form form={props.form} layout="vertical" onFinish={handleSubmit}>
      <FormItem name="firstName" label="First Name" { ...fieldsConfig.firstName }>
          <Input placeholder="Enter first name" />
      </FormItem>

      <FormItem name="lastName" label="Last Name" { ...fieldsConfig.lastName }>
          <Input placeholder="Enter last name" />
      </FormItem>

      <Form.Item name="username" label="Email Address" { ...fieldsConfig.username }>
          <Input placeholder="Enter email" />
      </Form.Item>

      <Form.Item name="location" label="Location" { ...fieldsConfig.location }>
          <Input placeholder="Enter location" />
      </Form.Item>

      <MobileNumber name="phone" label="Mobile Number" required />

      {
      !isSuperAdmin && <FormItem name="role" label="Access Level" rules={fieldsConfig.role.rules}>
        <Select placeholder="Select a role">
          {
            roles.map((role) => {
              return <Select.Option key={role} value={role}>{HUMAN_READABLE_SYSTEM_ROLES[role]}</Select.Option>
            })
          }
        </Select>
      </FormItem>
      }

      <Form.Item>
        <Button className="margin-top-2" block type="primary" htmlType="submit">Save Changes<CustomIcon name="Check" /></Button>
      </Form.Item>

      <Form.Item>
        <Button className="margin-top-2" block onClick={() => setShowResetUserPasswordModal(true)}>Reset Password<CustomIcon name="Reset" /></Button>
      </Form.Item>

      <Form.Item>
        <Button className="margin-top-2" block onClick={() => setShowActivateDeactivateUserModal(true)}>{user.enabled ? 'Deactivate Account' : 'Activate Account'}<CustomIcon name="DeleteTrash" /></Button>
      </Form.Item>
    </Form>
    <ActivateOrDeactivateUser visible={showActivateDeactivateUserModal} onCancel={() => setShowActivateDeactivateUserModal(false)} user={user} />
    <ResetPassword visible={showResetUserPasswordModal} onCancel={() => setShowResetUserPasswordModal(false)} user={user}></ResetPassword>
    </>
  )
}

let EditUserForm = (props) => {
  const [form] = Form.useForm();
  return <EditUserFormComponent form={form} {...props} />;
};

const EditUserModal = (props) => {
  const { visible, onCancel, ...rest } = props

  return (
    (<Modal
      open={visible}
      title={
        <div className="flex-horizontal-gap-4">
          <CustomIcon name="Edit" width={40} height={40} />
          <Typography.Title level={2} style={{ margin: 0 }}>Edit User</Typography.Title>
        </div>
      }
      onCancel={onCancel}
      footer={null}
      width={800}
      bodyStyle={{
        maxHeight: '70vh',
        overflowY: 'auto'
      }}
    >
      <EditUserForm {...rest} />
    </Modal>)
  );
}

const mapStateToProps = (state) => {
  return {
    resources: state.authorisation.resources,
    loggedInUser: state.auth.loggedInUser,
    currentRole: state.auth.currentRole
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllUsers: () => {
      return dispatch(getAllUsersRequest()).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },
    getUserPermissionTemplate: (userId) => {
      return dispatch(getUserPermissionTemplateRequest(userId)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    getUserRequest: (id) => {
      return dispatch(getUserRequest(id)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    updateUserRequest: (userId, data) => {
      return dispatch(updateUserRequest(userId, data)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    getUserProfileImage: (id) => {
      return dispatch(getUserProfileImage(id, false)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },
  }
};

const EditUser = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditUserModal);

export default EditUser;
